import { useRestricted } from '@procureai/permissions-ui';
import { NavListItemToolTipContent, NavListItem } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';
import { Link, useMatch } from 'react-router-dom';
import { useAnalytics } from 'use-analytics';

import { NavItemConfig } from '~/common/types';

export interface NavListItemLinkProps extends NavItemConfig {
  selected?: boolean;
  onClick?: (id: string) => void;
}

export const NavListItemLink = ({ Icon, to, upcoming, id, needs, selected, onClick }: NavListItemLinkProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Nav' });
  const { track } = useAnalytics();
  const match = useMatch({ path: `${to}/*`, end: true });
  const hasPermissions = useRestricted(needs);
  const label = t(id);

  if (hasPermissions) {
    const linkProps = to && {
      component: Link,
      to,
    };
    return (
      <NavListItem
        {...linkProps}
        selected={selected !== undefined ? selected : !!match}
        onClick={() => {
          track('Main Nav Link Click', { name: label });
          if (onClick) {
            onClick(id);
          }
        }}
        key={id}
        disabled={upcoming}
        tooltip={<NavListItemToolTipContent label={label} badge={upcoming ? t('upcoming') : undefined} />}
        data-intercom-target={`MainNav ${id}`}
      >
        {Icon && <Icon />}
      </NavListItem>
    );
  }

  return null;
};
